<template>
  <div
    :class="[
      classExtra,
      'w-full relative flex items-center',
      !url && !media?.url && !mate?.mediaUrl && 'bg-neutral',
    ]"
    @click.once="onClickImage"
  >
    <VanImage
      :class="[`w-full ${original ? '' : 'pointer-events-none'}`]"
      :fit="fit"
      :src="src.replace('/thumb', '/public')"
      class="img-container h-full"
      crossorigin="anonymous"
      @load="imgLoad"
    >
      <!-- <template v-slot:loading>
        <VanLoading size="20" type="spinner" />
      </template> -->
    </VanImage>
    <div
      v-if="isGif && showGif"
      class="absolute bottom-2 right-1 w-7 h-5 bg-[rgba(0,0,0,0.5)] rounded-[4px] flex items-center justify-center text-white text-xs"
      @click.stop.once="onClickImage"
    >
      <div class="text-xs">GIF</div>
    </div>

    <!-- 相册资源需要付费解锁 -->
    <div
      v-if="!hideModal && mateMedia?.isUnlockRequired === true"
      class="absolute top-0 left-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] rounded-[4px] flex items-center justify-center"
    >
      <button
        class="btn btn-private btn-sm flex items-center mt-5"
        @click.stop="clickUnlockImg"
        @mousedown.stop
        @mouseup.stop
      >
        <img
          :src="useCrystalUrl()"
          alt=""
          class="w-[20px] h-[20px]"
          crossorigin="anonymous"
        />
        <span>{{ mateMedia.crystalPrice }}</span>
      </button>
    </div>

    <!-- 需要付费解锁 -->
    <div
      v-else-if="
        !hideModal &&
        ((entity?.isPaid === 0 && entity.isNsfw === 1) ||
          chatMessage?.imageMessageIsPaid === 0)
      "
      class="absolute top-0 left-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] rounded-[4px] flex items-center justify-center"
    >
      <button
        class="btn btn-private btn-sm flex items-center mt-5"
        @click.stop="clickUnlockImg"
        @mousedown.stop
        @mouseup.stop
      >
        <i class="iconfont icon-heart-fill"></i>
        <span v-if="entity?.isPaid === 0">{{ $t(`nsfw.img.unlock`) }}</span>
        <span>{{ price }}</span>
        <img
          :src="useCrystalUrl()"
          alt=""
          class="w-[20px] h-[20px]"
          crossorigin="anonymous"
        />
      </button>
    </div>

    <!-- 需要点击去除遮照 -->
    <div
      v-else-if="
        !hideModal &&
        isShowNsfw &&
        media?.isNsfw &&
        !entity &&
        userStore.user.isNsfwBlurry
      "
      class="absolute top-0 left-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] rounded-[4px] flex items-center justify-center text-white text-xs backdrop-filter backdrop-blur-sm"
      @click.stop="clickNsfwContent(false)"
    >
      <div
        class="flex flex-col gap-2.5 items-center px-2 text-center font-semibold"
      >
        <i class="iconfont icon-eye-slash text-[30px]"></i>

        <div
          v-if="showAllContent"
          class="flex flex-col gap-2.5 items-center px-2 text-center font-semibold"
          @click.stop="clickNsfwContent(true)"
        >
          <h3 class="text-base mt-1">{{ $t(`nsfw.img.title`) }}</h3>
          <p class="text-sm">{{ $t(`nsfw.img.content`) }}</p>

          <button
            class="btn btn-private btn-sm flex items-center mt-5"
            @click.stop="clickNsfwContent(true)"
          >
            <i class="iconfont icon-eye-regular"></i>
            <span>{{ $t(`nsfw.img.view`) }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 本人相册右上角付费资源的标识 -->
    <div
      v-if="
        mateMedia?.mateId === mateStore.currentMate?.id &&
        mateMedia?.visibility! >= 6
      "
      class="absolute top-2 right-1 px-1 h-5 bg-[rgba(0,0,0,0.5)] rounded-[4px] flex items-center justify-center text-white text-xs gap-0.5"
    >
      <CrystalIcon />
      <span>{{ mateMedia?.crystalPrice }}</span>
    </div>

    <NSFWModalCrystalNotEnough
      v-model:show="showConfirmCrystalNotEnough"
      :miss-amount="missAmount"
      @mousedown.stop
      @mouseup.stop
    />
  </div>
</template>

<script lang="ts" setup>
import { useCrystalUrl, useDefaultAvatar } from "@/use/common";
import NSFWModalCrystalNotEnough from "@/views/NSFW/Modal/NSFWModalCrystalNotEnough.vue";
import { showLoadingToast, showSuccessToast } from "vant";
import { computed, onMounted, PropType, ref } from "vue";
import { ApiPutTextImagePayOne, ApiPutChatImagePayOne } from "@/apis/paint";
import { useGlobalUser } from "@/stores/globalUser";
import { useI18n } from "vue-i18n";
import { useMate } from "@/stores/mate";
import { ApiPostMediaOrder } from "@/apis/payment";
import { useTask } from "@/stores/task";
import { ChatMessage, Mate, MateMedia, TextImage, Media } from "@/types/entity";

const props = defineProps({
  url: {
    type: String,
  },
  ratio: {
    type: String,
    default: "",
  },
  width: {
    type: Number,
    default: 0,
  },
  media: {
    type: Object as PropType<Media>,
    default: () => ({}),
  },
  fit: {
    type: String,
    default: "contain",
  },
  highQuality: {
    type: Boolean,
    default: false,
  },
  original: {
    type: Boolean,
    default: false,
  },
  entity: {
    type: Object as PropType<TextImage>,
    default: undefined,
  },
  chatMessage: {
    type: Object as PropType<ChatMessage>,
    default: undefined,
  },
  isShowNsfw: {
    type: Boolean,
    default: true,
  },
  mateMedia: {
    type: Object as PropType<MateMedia>,
  },
  mate: {
    type: Object as PropType<Mate>,
  },
  price: {
    type: Number,
    default: 2,
  },
  classExtra: {
    type: String,
    default: "",
  },
});

const emit = defineEmits<{
  (e: "loaded"): void;
}>();

const { t } = useI18n();
const userStore = useGlobalUser();
const mateStore = useMate();
const taskStore = useTask();

const showAllContent = ref(false);

const getImageWidth = () => {
  let { ratio, width } = props;
  if (width) return width;
  if (!ratio) ratio = "3:4";
  if (ratio === "1:1") return 768;
  if (ratio === "3:4") return 768;
  if (ratio === "16:9") return 1280;
  return 768;
};

const src = ref("");
const ratio = ref("");
const showGif = ref(false);
const missAmount = ref(2);
const replacedRatio = computed(() => ratio.value.replace(":", "/"));

const onClickImage = () => {
  if (!isGif.value) return;
  src.value =
    getUrl() +
    `?x-oss-process=image/resize,w_${getImageWidth()}/format,webp/quality,q_80`;
  showGif.value = false;
};

const imgLoad = (e: any) => {
  emit("loaded");
  const { width, height } = e.target;
  // showAllContent.value = height >= 200 && width >= 250;
  if (props.ratio || props.media?.width) return;
  else if (width && height) ratio.value = `${width}/${height}`;
  else ratio.value = "3/4";
};

const isGif = computed(() => {
  const { url, media } = props;
  return (url ?? media?.url ?? "").endsWith(".gif");
});

const getUrl = () => {
  const { url, media, mate } = props;
  return url ?? media?.url ?? mate?.mediaUrl ?? "";
};

const hideModal = ref(false);

const clickNsfwContent = (isBtn: boolean) => {
  if (isBtn || !showAllContent.value) {
    props.media!.isNsfw = 0;
    hideModal.value = true;
  }
};

const showConfirmCrystalNotEnough = ref(false);
const clickUnlockImg = async () => {
  let price = props.mateMedia?.crystalPrice || props.price;
  if (userStore.user.crystalQuantity < price) {
    missAmount.value = price - userStore.user.crystalQuantity;
    return (showConfirmCrystalNotEnough.value = true);
  }
  const loading = showLoadingToast(t(`Message.unlocking`));
  try {
    if (props.chatMessage?.imageMessageIsPaid === 0) {
      const res = await ApiPutChatImagePayOne(props.chatMessage!.id!);
      userStore.user.crystalQuantity -= price;
      src.value = props.media.url = res.item.imageMessageMedia.url;
      props.media.isNsfw = 0;
      hideModal.value = true;
      props.chatMessage.imageMessageIsPaid = 1;
    } else if (props.entity?.isPaid === 0) {
      const res = await ApiPutTextImagePayOne(props.entity!.id!);
      userStore.user.crystalQuantity -= price;
      src.value = props.media.url = res.item.media.url;
      props.media.isNsfw = 0;
      hideModal.value = true;
      props.entity!.isPaid = 1;
      taskStore.galleryListExpired = true;
    } else if (props.mateMedia?.isUnlockRequired === true) {
      const res = await ApiPostMediaOrder({
        purchaserId: mateStore.currentMate?.id!,
        mediaIdzz: [props.media?.id!],
      });
      userStore.user.crystalQuantity -= price;
      src.value = props.media.url = res.itemzz[0].media.url;
      props.mateMedia.isUnlockRequired = false;
      props.media.isNsfw = 0;
      hideModal.value = true;
    }
    loading.close();
    showSuccessToast(t(`Message.unlockSuccess`));
  } catch (e: any) {
    loading.close();
    console.log(e);
    if (
      ["Insufficient crystals", "水晶不足"].includes(e.response.data.message)
    ) {
      showConfirmCrystalNotEnough.value = true;
    }
  }
};

const clickUnlockMateMedia = async () => {
  // userStore.openBuyItemModal(props.mateMedia!, props.media!, props.mate!);
  // await ApiPostMediaOrder({
  //   purchaserId: mateStore.currentMate?.id!,
  //   mediaIdzz: [props.mateMedia?.id!],
  // });
};

onMounted(() => {
  const { highQuality, ratio: _ratio, original } = props;
  let _url = getUrl();
  if (!_url) {
    src.value = useDefaultAvatar();
  } else if (original || _url.includes(".webp")) {
    src.value = _url.includes("?") ? _url.replace(/\?.+/g, "") : _url;
  } else if (_url.includes("?")) {
    src.value = _url;
  } else if (highQuality) {
    src.value = _url + `?x-oss-process=image/format,webp`;
  } else {
    src.value =
      _url +
      `?x-oss-process=image/resize,w_${getImageWidth()}/format,webp/quality,q_80`;
  }
  if (_ratio) {
    ratio.value = _ratio.replace(":", "/");
  } else {
    const { width, height } = props.media || {};
    if (!width || !height) return;
    ratio.value = `${width}/${height}`;
  }
});
</script>
<style lang="postcss" scoped>
.img-container {
  --ratio: v-bind(replacedRatio);
  aspect-ratio: var(--ratio);
}
</style>
